const stripWorkbookExtension = (fileName = "") =>
  String(fileName || "").replace(/\.(xlsx|xls|json)$/i, "");

export const normalizeQAFeedbackFileName = (fileName = "") => {
  const baseName = stripWorkbookExtension(fileName).replace(/_qa$/i, "");
  return `${baseName}_qa.xlsx`;
};

export const getQaDiffJsonPath = (qaFileFullPath = "") => {
  const path = String(qaFileFullPath || "").trim();
  if (!path) return "";

  if (/_qa\.xlsx$/i.test(path)) {
    return path.replace(/_qa\.xlsx$/i, "_diff.json");
  }

  return `${stripWorkbookExtension(path)}_diff.json`;
};